import { render, staticRenderFns } from "./TimePeriod.vue?vue&type=template&id=13ba736c&scoped=true"
import script from "./TimePeriod.vue?vue&type=script&lang=js"
export * from "./TimePeriod.vue?vue&type=script&lang=js"
import style0 from "./TimePeriod.vue?vue&type=style&index=0&id=13ba736c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ba736c",
  null
  
)

export default component.exports